import { useTranslations } from 'next-intl'
import { useBookingState } from '../../../state/booking.context'
import TicketLine from './TicketLine'
import { formatPrice } from '../../../lib/money'

export default function AddonsList() {
  const { cart } = useBookingState()
  const t = useTranslations('booking')
  if (!cart) return null

  return (
    <>
      {cart.addons.map((line, i) => {
        const richLine = t.rich('ticket.summaryBox.addonItem', {
          variant: t(`addonKeys.${line.category}`),
          price: formatPrice(line.unitValue * 100),
          perPerson: line.quantity > 1 ? t('ticket.summaryBox.perPerson') : '',
          priceElement: (chunks) => <span>{chunks}</span>,
        })

        return <div key={i}>{richLine}</div>
      })}
    </>
  )
}
